import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ClipLoader from "react-spinners/ClipLoader";
// import PoweredBy from "./images/powered_by.png";
import axios from "axios";
// import TextField, { TextFieldProps } from '@mui/material/TextField';
import InputBase from "@mui/material/InputBase";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { alpha, styled } from "@mui/material/styles";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Grid from "@mui/material/Unstable_Grid2";
import { getApiBaseUrl } from '../utils/getEnvironmentConfig'
import transact from "../images/transact.jpg"
import Transact from "../images/applogo.svg"
import SuccessLogo from "../images/payment-success.svg"
import failedLogo from "../images/payment-failed.svg"


function ViewPaymentLinkDetails() {
  const { linkref } = useParams();
  const [paymentData, setPaymentData] = useState();
  const [PaymentError, setPaymentError] = useState();
  const [PaymentSuccess, setPaymentSuccess] = useState();
  const [keys, setKeys] = useState();
  const [frequencies, setFrequencies] = useState();

  const getPaymentLink = async () => {
    try {
      const { status, data } = await axios.get(
        `${getApiBaseUrl()}/paymentlink/info?reference=${linkref}`
      );
      status == 200 && setPaymentData(data?.data);
    } catch (error) {
      setPaymentError(error?.response?.data ?? { message: "Unable to load payment details" })
    }
  }

  const getPaymentLinkKeys = async () => {
    try {
      const { status, data } = await axios.post(
        `${getApiBaseUrl()}/paymentlink/get-keys`,
        {
          reference: linkref
        }
      );
      status == 200 && setKeys(data?.data);
    }
    catch (error) {
      setPaymentError(error?.response?.data ?? { message: "Unable to load payment details" })
    }
  }

  const getFrequency = async () => {
    try {
      const { status, data } = await axios.get(
        `${getApiBaseUrl()}/frequencies`);
      status == 200 && setFrequencies(data?.data);
    }
    catch (error) {
      setPaymentError(error?.response?.data ?? { message: "Unable to load payment details" })
    }
  }

  useEffect(() => {
    getPaymentLink();
    getPaymentLinkKeys();
    getFrequency();
  }, []);

  const StyledFormControl = styled(FormControl)(({ theme }) => ({
    marginBottom: "22px",
  }));

  const BootstrapInput = styled(InputBase)(({ theme }) => ({
    "label + &": {
      marginTop: theme.spacing(3)
    },
    "& .MuiInputBase-input": {
      borderRadius: 4,
      position: "relative",
      backgroundColor: theme.palette.mode === "light" ? "#fcfcfb" : "#2b2b2b",
      border: "1px solid #efe0d0",
      fontSize: 16,
      width: "100%",
      padding: "10px 12px",
      transition: theme.transitions.create([
        "border-color",
        "background-color",
        "box-shadow"
      ]),
      // Use the system font instead of the default Roboto font.
      fontFamily: [
        "-apple-system",
        "BlinkMacSystemFont",
        '"Segoe UI"',
        "Roboto",
        '"Helvetica Neue"',
        "Arial",
        "sans-serif",
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"'
      ].join(","),
      "&:focus": {
        boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
        borderColor: theme.palette.primary.main
      }
    }
  }));
  const getSubLogo = () => {
    return paymentData?.paymentLink?.logo;
  }
  const PaymentLink = () => {
    // const { logo, companyName, merchantName } = paymentData;
    // const {
    //   linkName,
    //   linkType,
    //   amount,
    //   currency,
    //   description,
    //   redirectUrl,
    //   pageImage,
    //   donationWebsite,
    //   donationContact
    // } = paymentData?.link;

    const [usefallbackLogo, setUsefallbackLogo] = useState(false);
    const [checkoutPayload, setCheckoutPayload] = useState({
      amount: paymentData?.paymentLink?.amount ?? 0,
      frequencyId: paymentData?.paymentLink?.paymentLinkCode == "SUB" ? 1 : null,
    });

    const updateValueHandler = (prop, value) => {
      setCheckoutPayload((prev) => ({
        ...prev,
        [prop]: value
      }));
    };

    const { fname, lname, phoneNumber, email, description, amount, frequencyId, numberOfPayment } =
      checkoutPayload;

    const makePayment = () => {
      const Checkout = new window.CheckoutNS.PaymentCheckout({
        firstName: fname,
        lastName: lname,
        mobile: phoneNumber,
        country: paymentData?.subsidiary?.country || country,
        email: email,
        currency: paymentData?.paymentLink?.currency,
        amount: amount,
        reference: keys?.paymentReference,
        merchantReference: keys?.paymentReference,
        description: description,
        apiKey: keys?.publicKey,
        encryptionKey: keys?.publicEncryptionKey,
        cab: paymentData.paymentLink.authOption == "NOAUTH" ? "c1" : "",
        frequencyId: frequencyId,
        numberOfPayment: numberOfPayment,
        paymentLinkId: paymentData.paymentLink.id,

        onCompleted: (data) => {
          if (data?.status?.toLowerCase() == "successful") {
            setPaymentSuccess({ message: data.message ?? "Payment attempt successful" })
          }
          else {
            setPaymentError({ message: data.message ?? "Payment attempt failed, please try again" })
          }
        },
        onClose: (dd) => {
          // setPaymentError({
          //   message: "Payment cancelled, Please refresh"
          // })
        },
        onError: (error) => {
          setPaymentError({ message: error.message ?? "Payment attempt failed, please try again" })
        }
      });
      Checkout.init();
      return;
    };
    const handleSubmit = (e) => {
      e.preventDefault();
      makePayment();
    };
    return (
      <div id="link-wrapper">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginBottom: "32px"
          }}
        >
          <div style={{ marginTop: "30px" }}>
            {!usefallbackLogo && <img
              style={{ borderRadius: "50%", objectFit: "cover", border: "1px solid grey" }}
              width="70px"
              height="70px"
              src={getSubLogo()}
              alt="Sub Logo"
              onError={(e) => {
                setUsefallbackLogo(true);
                // e.target.onerror = null;
                // e.target.src = Transact;
              }}
            />}

            {usefallbackLogo && <img
              style={{ objectFit: "cover" }}
              width="150px"
              // height="70px"
              src={Transact}
              alt="Sub Logo"
              onError={(e) => {
                // setUsefallbackLogo(true);
                // e.target.onerror = null;
                // e.target.src = Transact;
              }}
            />}

          </div>
          <div
            style={{
              marginTop: "20px",
              marginBottom: "24px"
            }}
          >
            {paymentData?.subsidiary?.name}
          </div>
          <div>Payment for <span style={{ fontWeight: "bold" }}>{paymentData?.paymentLink?.description ?? paymentData?.subsidiary?.name} </span> </div>
        </div>
        <div id="payment-link"        >
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid xs={12} md={6}>
                <StyledFormControl variant="standard" fullWidth>
                  <InputLabel style={{ fontSize: "1.3rem" }} shrink htmlFor="bootstrap-input">
                    First Name
                  </InputLabel>
                  <BootstrapInput
                    required
                    name="firstname"
                    id="bootstrap-input"
                    fullWidth
                    onChange={(e) =>
                      updateValueHandler("fname", e.target.value)
                    }
                  />
                </StyledFormControl>
              </Grid>
              <Grid xs={12} md={6}>
                <StyledFormControl variant="standard" fullWidth>
                  <InputLabel style={{ fontSize: "1.3rem" }} shrink htmlFor="bootstrap-input">
                    Last Name
                  </InputLabel>
                  <BootstrapInput
                    required
                    name="lastname"
                    id="bootstrap-input"
                    fullWidth
                    onChange={(e) =>
                      updateValueHandler("lname", e.target.value)
                    }
                  />
                </StyledFormControl>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid xs={12} md={6}>
                <StyledFormControl variant="standard" fullWidth>
                  <InputLabel style={{ fontSize: "1.3rem" }} shrink htmlFor="bootstrap-input">
                    Email Address
                  </InputLabel>
                  <BootstrapInput
                    required
                    name="emailaddress"
                    type="email"
                    placeholder="customer@mail.com"
                    id="bootstrap-input"
                    onChange={(e) => updateValueHandler("email", e.target.value)}
                  />
                </StyledFormControl>
              </Grid>
              <Grid xs={12} md={6}>
                <StyledFormControl variant="standard" fullWidth>
                  <InputLabel style={{ fontSize: "1.3rem" }} shrink htmlFor="bootstrap-input">
                    Phone Number
                  </InputLabel>
                  <BootstrapInput
                    required
                    type="tel"
                    name="mobilenumber"
                    placeholder="+23481356674"
                    id="bootstrap-input"
                    onChange={(e) =>
                      updateValueHandler("phoneNumber", e.target.value)
                    }
                  />
                </StyledFormControl>
              </Grid>
            </Grid>
            <StyledFormControl variant="standard" fullWidth>
              <InputLabel style={{ fontSize: "1.3rem" }} shrink htmlFor="bootstrap-input">
                Description
              </InputLabel>
              <BootstrapInput
                required
                name="description"
                type="name"
                placeholder="Payment description"
                id="bootstrap-input"
                onChange={(e) =>
                  updateValueHandler("description", e.target.value)
                }
              />
            </StyledFormControl>
            <StyledFormControl variant="standard" fullWidth>
              <InputLabel style={{ fontSize: "1.3rem" }} shrink htmlFor="bootstrap-input">
                Amount to charge ({paymentData?.paymentLink?.currency})
              </InputLabel>
              <BootstrapInput
                required
                type="number"
                name="amount"
                value={paymentData?.paymentLink?.amount}
                defaultValue={paymentData?.paymentLink?.amount}
                id="bootstrap-input"
                disabled={paymentData?.paymentLink?.amount > 0}
                onChange={(e) => updateValueHandler("amount", e.target.value)}
              />
            </StyledFormControl>
            {paymentData?.paymentLink?.paymentLinkCode == "SUB" &&
              <Grid container spacing={2}>
                <Grid xs={12} md={12}>
                  <p style={{ padding: "10px 0px 20px 0", fontWeight: "bold", color: "#24BBA1" }}>Setup Subscription for this payment</p>
                  <StyledFormControl variant="standard" fullWidth>
                    <InputLabel style={{ fontSize: "1.3rem", paddingBottom: "20px" }} shrink htmlFor="bootstrap-input">
                      Frequency
                    </InputLabel>
                    <Select required defaultValue={checkoutPayload.frequencyId} onChange={(e) => updateValueHandler("frequencyId", e.target.value)}>
                      {
                        frequencies?.map(f => (
                          <MenuItem key={f.id + f.name} value={f.id}>{f.name}</MenuItem>
                        ))
                      }
                    </Select>
                  </StyledFormControl>
                </Grid>
                <Grid xs={12} md={12}>
                  <StyledFormControl variant="standard" fullWidth>
                    <InputLabel style={{ fontSize: "1.3rem" }} shrink htmlFor="bootstrap-input">
                      Number of Payment (optional)
                    </InputLabel>
                    <BootstrapInput
                      type="number"
                      name="amount"
                      defaultValue={paymentData?.paymentLink?.numberOfPayment}
                      id="bootstrap-input"
                      onChange={(e) => updateValueHandler("numberOfPayment", e.target.value)}
                    />
                  </StyledFormControl>
                </Grid>
              </Grid>}
            <button
              style={{
                width: "100%",
                height: "54px",
                backgroundColor: "#24BBA1",
                color: "white",
                border: "none",
                fontSize: "17px",
                borderRadius: "7px",
                cursor: "pointer"
              }}
              type="submit"
            >
              Initiate Payment
            </button>
          </form>
        </div>
        <div style={{ marginBottom: "20px" }}>
          <p style={{ border: "1px solid grey", fontWeight: "800", fontSize: "12px", padding: "5px 10px", borderRadius: "5px", color: "gray", display: 'flex', alignItems: 'center' }}>Powered By  <img src={transact} alt="" style={{ width: "15px", height: "15px", position: "relative", top: "2px" }} /></p>
        </div>
      </div>
    );
  };

  if (PaymentError) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", color: "red", fontSize: "25px" }}>
        <img src={failedLogo} alt="" />
        <p>{PaymentError?.message ?? "Unable to load payment link details"}</p>
      </div>
    )
  }
  if (PaymentSuccess) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", color: "green", fontSize: "25px", flexDirection: 'column' }}>
        <img src={SuccessLogo} alt="" />
        <p>{PaymentSuccess?.message ?? "Payment completed successfully"}</p>
        <div>
          <button id="primary-button" style={{ backgroundColor: 'green' }} onClick={() => window.location.reload()}>Refresh </button>
        </div>
      </div>
    )
  }
  if (!paymentData) {
    return (
      <div id="loader">
        <ClipLoader
          color="#24BBA1"
          loading={true}
          size={150}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
      </div>
    );
  }

  return <>{paymentData && <PaymentLink />}</>;
}

export default ViewPaymentLinkDetails;
